export const environment = {
  production: false,
  TITLE: 'MISA',
  API_URL: 'https://misa.coldbiz.eu/v1/',
  DOCS_URL: 'https://misa.coldbiz.eu/docs/',
  TICKETSATTACHMENTS_URL: 'https://misa.coldbiz.eu/tickets_attachments/',
  VERSION_NUMBER: '1.0.0',
  VERSION_DATE: new Date('2025-02-19')
};
